import { useContext, useState, useRef } from "react";
import AuthContext from "context/AuthContext";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { SwalAlertClass } from "core/swalClass";

const LoginOTP = () => {
    const { verifyOtp, pendingOtp } = useContext(AuthContext);
    const { t: _Ta } = useTranslation("authenticate");
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resent, setResent] = useState(false);
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });

    const inputRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    const isEmail = pendingOtp?.otp_type === "email";

    const handleSubmit = async (e) => {
        e.preventDefault();
        const code = otp.join("");
        if (code.length < 6) {
            setError(true);
            return;
        }
        setLoading(true);
        setError(false);
        const resp = await verifyOtp(code);
        if (!resp?.status) {
            Alert.error(_Ta("messages.error-otp"));
            setError(true);
        }
        setLoading(false);
    };

    const handleChange = (value, index) => {
        const cleanValue = value.replace(/[^0-9]/g, "");
        if (!cleanValue) {
            const newOtp = [...otp];
            newOtp[index] = "";
            setOtp(newOtp);
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = cleanValue.substring(cleanValue.length - 1);
        setOtp(newOtp);

        if (index < 5) {
            inputRefs[index + 1].current.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (!otp[index] && index > 0) {
                const newOtp = [...otp];
                newOtp[index - 1] = "";
                setOtp(newOtp);
                inputRefs[index - 1].current.focus();
                e.preventDefault();
            } else if (otp[index]) {
                const newOtp = [...otp];
                newOtp[index] = "";
                setOtp(newOtp);
                e.preventDefault();
            }
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData("text");
        if (pasteData.length === 6 && /^\d+$/.test(pasteData)) {
            const newOtp = pasteData.split("");
            setOtp(newOtp);
            inputRefs[5].current.focus();
            e.preventDefault();
        }
    };

    const handleResend = async () => {
        setResent(false);
        setError(false);
        try {
            await axios.post("/api/two-factor/send-login-code/", {
                email: pendingOtp.email,
                password: pendingOtp.password,
            });
            setResent(true);
        } catch {
            setError(true);
        }
    };

    return (
        <div className="form-signin w-100 m-auto">
            <form onSubmit={handleSubmit}>
                <h1 className="h5 mb-3 fw-normal text-center">
                    {_Ta("title.otp")}
                </h1>
                <p className="mb-2 text-center">
                    {isEmail ? _Ta("title.otp-desc-email") : _Ta("title.otp-desc")}
                </p>
                {resent && (
                    <p className="text-success text-center mb-2">{_Ta("messages.email-resent")}</p>
                )}
                {error && (
                    <p className="error-message text-center bg-danger text-light">
                        {_Ta("messages.error-otp")}
                    </p>
                )}
                <div className="d-flex gap-2 justify-content-center mb-3">
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            ref={inputRefs[index]}
                            type="text"
                            className="form-control text-center"
                            style={{
                                width: "45px",
                                height: "50px",
                                fontSize: "20px",
                                fontWeight: "bold",
                            }}
                            maxLength={1}
                            value={digit}
                            onChange={(e) => handleChange(e.target.value, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            onPaste={handlePaste}
                            autoFocus={index === 0}
                        />
                    ))}
                </div>
                <button className="btn btn-primary w-100" type="submit" disabled={loading}>
                    {_Ta("buttons.verify-otp")}
                </button>
                {isEmail && (
                    <button
                        type="button"
                        className="btn btn-link w-100 mt-2"
                        onClick={handleResend}
                        disabled={loading}
                    >
                        {_Ta("buttons.resend-code")}
                    </button>
                )}
            </form>
        </div>
    );
};
export default LoginOTP;